import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from "@angular/core";
import { environment } from "../../../environments/environment";
import { Feature } from "../../interfaces/feature";
import { Epic } from "../../interfaces/epic";
import { MzBaseModal } from "ng2-materialize";
import { Project } from "../../interfaces/project";
import { Utils } from "../../utils/utils";
import { EditThemeDialogComponent } from "../edit-theme-dialog/edit-theme-dialog.component";

@Component({
  selector: "app-edit-annotation-dialog",
  templateUrl: "./edit-annotation-dialog.component.html",
  styleUrls: ["./edit-annotation-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditAnnotationDialogComponent
  extends MzBaseModal
  implements OnInit {
  readonly env: any = environment;
  readonly utils: any = Utils;

  @Input() editThemeDialog: EditThemeDialogComponent;
  @Input() themes: Array<Epic>;
  @Input() project: Project;

  @Output() createItemClicked: EventEmitter<any> = new EventEmitter<any>();

  newItem: Feature;
  selectedTheme = "Theme auswählen" as string;

  constructor() {
    super();
  }

  ngAfterViewInit() {}

  ngOnInit() {
    this.newItem = {} as Feature;
  }

  /**
   * creates new Item
   */
  createItem() {
    this.newItem.projectId = this.project._id;
    this.createItemClicked.emit(this.newItem);
    this.newItem = {} as Feature;
    this.selectedTheme = "Theme auswählen";
  }

  /**
   * resets newItem object and closes modal
   * @param modal
   */
  closeItemModal() {
    this.newItem = {} as Feature;
    this.selectedTheme = "Theme auswählen";
  }

  selectThemeId(themeId) {
    this.newItem.epicId = themeId;
  }

  setSelectedThemeID(themeID: string, theme: string) {
    this.selectedTheme = theme;
    this.newItem.epicId = themeID;
  }

  async addThemeClick() {
    this.modalComponent.close();
    await this.editThemeDialog.getResultAsync();
    this.modalComponent.open();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/edit-annotation-dialog/edit-annotation-dialog.component.ts